// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Odej5","bigColWidth":"Table_bigColWidth__29pqV","biggerColWidth":"Table_biggerColWidth__q1QTv","row":"Table_row__18kcc","col":"Table_col__2B5Os"};